
import * as defaultImport from "uplot/dist/uPlot.min.css";
export * from "uplot/dist/uPlot.min.css";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
